
import React from "react";
import NavBar from "@/components/NavBar";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";

interface PlaceholderProps {
  title: string;
  description?: string;
  returnPath?: string;
  returnLabel?: string;
}

export default function Placeholder({ 
  title, 
  description = "This page is under construction", 
  returnPath = "/dashboard",
  returnLabel = "Back to Dashboard"
}: PlaceholderProps) {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main className="flex-1 container py-6">
        <Button variant="ghost" className="mb-6" onClick={() => navigate(returnPath)}>
          <ArrowLeft className="mr-2 h-4 w-4" /> {returnLabel}
        </Button>
        
        <div className="flex flex-col items-center justify-center py-16">
          <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
            <Info className="h-8 w-8 text-blue-600" />
          </div>
          <h1 className="text-3xl font-bold mb-2">{title}</h1>
          <p className="text-muted-foreground mb-6 text-center max-w-md">
            {description}
          </p>
          <Button onClick={() => navigate(returnPath)}>
            {returnLabel}
          </Button>
        </div>
      </main>
    </div>
  );
}
